export default __webpack_public_path__ + "static/media/goods_def.25032a40.jpg";